import { Card, CardHeader, Col, Container, Row } from "reactstrap";
import SimpleHeader from "../../components/SimpleHeader/SimpleHeader";
import Button from "../../components/UIButton/UIButton";

export default function DsaSenderPage() {
	return (
		<>
			<SimpleHeader
				name="Receiver"
				parentName="Data Sharing Agreements - Sender"
			/>
			<Container className="mt--6" fluid>
				<Row className="justify-content-center">
					<Col className="card-wrapper">
						<Card className="card-header-devices">
							<CardHeader>
								<Container fluid>
									<Row>
										<Col>
											<h2>Sent Agreements</h2>
										</Col>
									</Row>
									<Row>
										<Col >&nbsp;</Col>
										<Col className="justify-content-end d-flex">
											<Row className="my-2 align-items-center">

												<Button
													variant="primary"
													size="medium"
													onClick={() => { }}
												>
													Create New Agreement
												</Button>

											</Row>
										</Col>
									</Row>
								</Container>
							</CardHeader>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	);
}
